// import {useEffect, useState} from 'react'
import {useAppSelector} from '../redux/hooks'
import {authSelector} from '../redux/slices/authSlices'

export const useRoleUser = () => {
  const {user} = useAppSelector(authSelector)
  const roleUser = user?.credential?.role_flag ?? ''

  return {
    roleUser,
    isCustomer: roleUser === 'null' || roleUser === '',
    isAdmin: roleUser === 'admin',
    isSalesAdmin: roleUser === 'salesAdmin',
    isSalesAnper: roleUser === 'salesAnper',
    isOtorisator: roleUser === 'otorisator',
    isFinance: roleUser === 'finance',
  }
}
